<div class="title">
  <h1 class="wellcome-text">{{'WELCOME' | translate}}, {{user}}!</h1>
  <h3 class="message-text">{{'MESSAGE_WELCOME' | translate}}</h3>
</div>

<div class="container">
  <div class="cards-container">
    <div class="card">
      <div class="info card-title">{{ 'NUMBER_OF_CAMERAS' | translate }}</div>
      <div class="info card-main-info">
        <span class="card-ico card-total-ico">

        </span>
        <span class="card-number">
          {{ landingPageModel.camerasOnline }}
        </span>
      </div>
      <div class="info card-secondary-info">
        <span class="card-secondary-number">
          {{ landingPageModel.CamerasOfflineLastThirtyDays }}
        </span>
        <span class="card-secondary-text">
          {{ "CAMERAS_OFFLINE" | translate }}
          {{ "LAST_30_DAYS" | translate }}
        </span>
        <span class="divider"></span>
      </div>
      <div class="info card-rate-info">
        <span class="card-rate-icon" [ngClass]="{
          'card-rate-icon-positive': this.landingPageModel.CamerasOfflineEvolution > 0,
          'card-rate-icon-negative': this.landingPageModel.CamerasOfflineEvolution < 0
        }">

        </span>
        <span class="card-rate-percent" [ngClass]="{
          'card-rate-positive': this.landingPageModel.CamerasOfflineEvolution > 0,
          'card-rate-negative': this.landingPageModel.CamerasOfflineEvolution < 0
        }">
          {{ landingPageModel.CamerasOfflineEvolution }}%
        </span>
        <span class="card-rate-text">
          {{ "THIS_MONTH" | translate }}
        </span>
      </div>
      <div class="card-number-info card-number-info--cameras">{{ "CAMERAS_ONLINE" | translate }}</div>
    </div>
    <div class="card">
      <div class="info card-title">{{ 'TOTAL_INCIDENTS_RECORDED'| translate }}</div>
      <div class="info card-main-info">
        <span class="card-ico card-incident-ico">

        </span>
        <span class="card-number">
          {{ landingPageModel.RecordedIncidents }}
        </span>
      </div>
      <div class="info card-secondary-info">
        <span class="card-secondary-number">
          {{ landingPageModel.incidentsRecordedMonthlyAverage }}
        </span>
        <span class="card-secondary-text">
          {{ "MONTHLY_AVERAGE" | translate }}
          {{ "LAST_12_MONTHS" | translate }}
        </span>
        <span class="divider"></span>
      </div>
      <div class="info card-rate-info">
        <span  *ngIf="landingPageModel.incidentsRecordedVsLastThirtyDays !== 0" class="card-rate-icon"
        [ngClass]="{
          'card-rate-icon-positive': landingPageModel.incidentsRecordedVsLastThirtyDays < 0,
          'card-rate-icon-negative': landingPageModel.incidentsRecordedVsLastThirtyDays > 0
        }">
        </span>
        <span class="card-rate-percent " [ngClass]="{
          'card-rate-positive': landingPageModel.incidentsRecordedVsLastThirtyDays < 0,
          'card-rate-negative': landingPageModel.incidentsRecordedVsLastThirtyDays > 0
        }">

          <span *ngIf="landingPageModel.incidentsRecordedVsLastThirtyDays > 0">+</span>
          {{ landingPageModel.incidentsRecordedVsLastThirtyDays }}%
        </span>
        <span class="card-rate-text">
          {{ "VS_LAST_30_DAYS" | translate }}
        </span>
      </div>
      <div class="card-number-info">{{ "RECORDED_INCIDENTS" | translate }}</div>
    </div>
    <div class="card">
      <div class="info card-title">{{  'HOT_SPOTS' | translate }}</div>
      <span class="card-button btn-sites" (click)="RenderHotSpotBarChart()"></span>
      <span class="card-button btn-type-events" (click)="GenerateLinearChart()"></span>
      <span class="card-button btn-type-events-day" (click)="GenerateLinearChartByDay()"></span>
      <canvas class="chart-canvas" id="hotSpotChar"></canvas>
    </div>
    <div class="card">
      <div class="info card-title">{{ "MAIN_INCIDENTS_TYPES" | translate }}</div>
      <span class="card-button btn-main-incidents"></span>
      <canvas class="chart-canvas" id="mainIncidentChart"></canvas>
    </div>
  </div>
  <div class="lastest-container">
    <div class="lastest-main-title">
      {{ "LATEST_ALERTS" | translate }}
    </div>
    <div class="lastest-content">
      <div  *ngFor="let incident of lastIncidents" class="lastest-card">
        <span class="lastest-title">
          <p>{{ "TYPE" | translate }}: {{ incident.eventDescription }}</p>
          <!-- <p>12/07/2023  12:29:01 AM - BROOKSVILLE | SILO 5 A</p> -->
          <p>{{incident.occurred | date: 'dd/MM/yyyy hh:mm a' }} - {{  incident.site  }} | {{  incident.incidentArea  }} </p>
        </span>
        <span class="expand-ico" (click)="openCarousel(incident.carrouselModel)"></span>
        <!-- <span *ngIf="incident.type == 'imagen'" class="card-image" [ngStyle]="{'background-image': 'url(' + incident.firstImage + ')'}"></span> -->
        <!-- <video autoplay="true" *ngIf="incident.type == 'video'" [controls]="true"  class="clip-thumbnail"> 
          <source src="{{incident.firstImage}}" type="video/mp4">
        </video> -->
        <!-- <img *ngIf="incident.type == ''" class="card-image"> -->
        <img data-clarity-mask="true"  [src]="incident.firstImage" *ngIf="incident.isImage == true" class="card-image">
        <video data-clarity-mask="true"   *ngIf="incident.isImage == false" width="100%" height="100%" type="video/mp4" class="clip-thumbnail" autoplay loop [src]="incident.firstImage">
        </video>
      </div>



      
      <!-- <div class="lastest-card">
        <span class="lastest-title">
          <p>TYPE: UNSAFE TRUCK EXIT</p>
          <p>12/07/2023  12:29:01 AM - BROOKSVILLE | SILO 5 A</p>
        </span>
        <span class="expand-ico"></span>
        <span class="card-image"></span>
      </div>
      <div class="lastest-card">
        <span class="lastest-title">
          <p>TYPE: UNSAFE TRUCK EXIT</p>
          <p>12/07/2023  12:29:01 AM - BROOKSVILLE | SILO 5 A</p>
        </span>
        <span class="expand-ico"></span>
        <span class="card-image"></span>
      </div> -->
    </div>
  </div>
</div>